import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import { vueRouterDidFinishLoad } from "@/libs/jsBridge";
import { checkIsIOS } from "@/libs/utils";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "GoFun出行"
    }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登陆"
    },
    component: () => import("@/views/common/Login.vue")
  },
  {
    path: "/bargainSubscribe",
    name: "bargainSubscribe",
    meta: {
      title: "免费用车"
    },
    component: () => import("@/views/bargainSubscribe/index.vue")
  },
  {
    path: "/C2C/landPage",
    name: "landPage",
    meta: {
      title: "车闲放GoFun 安心把钱赚"
    },
    component: () => import("@/views/C2C/landPage.vue")
  },
  {
    path: "/C2C/car-brand",
    name: "carBrand",
    meta: {
      title: "品牌选择"
    },
    component: () => import("@/views/C2C/carBrand.vue")
  },
  {
    path: "/C2C/car-type",
    name: "carType",
    meta: {
      title: "车型选择"
    },
    component: () => import("@/views/C2C/carType.vue")
  },
  {
    path: "/C2C/car-service",
    name: "carService",
    meta: {
      title: "GoFun车主服务"
    },
    component: () => import("@/views/C2C/carService.vue")
  },
  {
    path: "/C2C/receive-success",
    name: "receiveSuccess",
    meta: {
      title: "领取成功"
    },
    component: () => import("@/views/C2C/receiveSuccess.vue")
  },
  {
    path: "/C2C/submit-success",
    name: "submitSuccess",
    meta: {
      title: "提交成功"
    },
    component: () => import("@/views/C2C/submitSuccess.vue")
  },
  {
    path: "/advertisingTest",
    name: "advertisingTest",
    meta: {
      title: "广告投放测试"
    },
    component: () => import("../views/advertisingTest.vue")
  },
  {
    path: "/sensorTest",
    name: "sensorTest",
    meta: {
      title: "神策测试"
    },
    component: () => import("../views/sensorTest.vue")
  },
  {
    path: "/zeroRun/zeroRunIndex",
    name: "zeroRunIndex",
    meta: {
      title: "零跑"
    },
    component: () => import("../views/zeroRun/zeroRun.vue")
  },
  {
    path: "/zeroRun/zeroRunBuyCar",
    name: "zeroRunBuyCar",
    meta: {
      title: "我要买车"
    },
    component: () => import("../views/zeroRun/zeroRunBuyCar.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

/**
 * 路由发生变化根据router的meta.title修改页面title
 */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

router.afterEach((to, from) => {
  if (to.meta.title) {
    // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
    if (checkIsIOS()) {
      vueRouterDidFinishLoad();
    }
  }
  console.log(`路由跳转 From："${from.fullPath}" --- To："${to.fullPath}"`);
});

export default router;
